import React from 'react';
import SectionSwitchSC from './section-switch.styled';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../../utils/default-lang';

const SectionSwitch = ({ categories, isActive, setActiveCategory }) => {
  return (
    <SectionSwitchSC>
      {categories.map((category) => {
        return (
          <button
            key={category.name}
            className={isActive === category.name ? 'active' : category.disabled ? 'disabled' : ''}
            onClick={category.disabled ? () => {} : () => setActiveCategory(category.name)}
            disabled={category.disabled}
          >
            <FormattedMessage id={category.label} defaultMessage={dlt[`${category.label}`]} />
          </button>
        );
      })}
    </SectionSwitchSC>
  );
};

export default SectionSwitch;
